import { useMemo, useState } from 'react';

import { User } from '@givebacks/api/core';
import { useSearchParams } from 'react-router-dom';
import { Alert, Divider, Stack, Title } from 'ui';

import AppleSignIn from '../../auth/AppleSignIn';
import { CreateAccountForm } from '../../auth/AuthModal/CreateAccountForm';
import { SignInForm } from '../../auth/AuthModal/SignInForm';
import GoogleSignIn from '../../auth/GoogleSignIn';
import { TermsAndConditions } from '../../auth/TermsAndConditions';

type AuthContentProps = {
  showSignIn: boolean;
  onFormSwitch: (isSignIn: boolean) => void;
  onSuccess: (user: User) => void;
};

const AuthContentForm = ({ showSignIn, onFormSwitch, onSuccess }: AuthContentProps) => {
  const [SSOError, setSSOError] = useState<string | undefined>(undefined);
  const [searchParams] = useSearchParams();

  // Ensure the current search params are included in redirect stored in localStorage
  const ssoRedirect = useMemo(() => `${searchParams.toString()}`, [searchParams]);

  return (
    <Stack gap="lg">
      <Title order={2} fz={24}>
        {showSignIn ? 'Sign In' : 'Create Account'}
      </Title>
      <Stack gap="xs">
        <AppleSignIn setThirdPartyAccountError={setSSOError} nextUrl={ssoRedirect} />
        <GoogleSignIn setThirdPartyAccountError={setSSOError} onSuccess={onSuccess} />
        <Alert.Collapse title={SSOError} type="error" in={!!SSOError} />
      </Stack>
      <Divider
        label="or"
        labelPosition="center"
        fw={600}
        color="cobalt.0"
        styles={(theme) => ({ label: { color: theme.colors.gray[8] } })}
      />
      {showSignIn ? (
        <SignInForm setIsSignIn={() => onFormSwitch(false)} onSuccessfulSignIn={onSuccess} />
      ) : (
        <CreateAccountForm setIsSignIn={() => onFormSwitch(true)} onSuccessfulSignUp={onSuccess} />
      )}
      <TermsAndConditions />
    </Stack>
  );
};
export { AuthContentForm };
